import tooltips from './tooltips';

export default {
  bng: {
    days: ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'],
    data: [
      {
        time: '8:00 AM',
        activities: [
          // [{
          //   type: 'relaxation',
          //   label: 'Power Walk',
          //   tooltip: tooltips.powerwalk
          // }],
          // [{
          //   type: 'physical',
          //   label: 'Tabata Training',
          //   tooltip: tooltips.tabata
          // }],
          // [{
          //   type: 'relaxation',
          //   label: 'Power Walk',
          //   tooltip: tooltips.powerwalk
          // }],
          // [{
          //   type: 'physical',
          //   label: 'Caribbean Beach Shred',
          //   tooltip: tooltips.caribnbchs
          // }],
          // [{
          //   type: 'physical',
          //   label: 'Absolute -ABS',
          //   tooltip: tooltips.absoluteabs
          // }],
          null,
          null
        ]
      },
      {
        time: '11:00 AM',
        activities: [
          // [{
          //   type: 'water',
          //   label: 'Aqua Tabata',
          //   tooltip: tooltips.aquatabata
          // }],
          // [{
          //   type: 'water',
          //   label: 'Aqua Fitness',
          //   tooltip: tooltips.aqua
          // }],
          // [{
          //   type: 'water',
          //   label: 'Splish-Splash',
          //   tooltip: tooltips.splish
          // }],
          // [{
          //   type: 'water',
          //   label: 'Aqua Tabata',
          //   tooltip: tooltips.aquatabata
          // }],
          // [{
          //   type: 'field',
          //   label: 'Kids Beach FUN',
          //   tooltip: tooltips.beachfun
          // }],
          null,
          null
        ]
      },
      {
        time: '3:00 PM',
        activities: [
          // [{
          //   type: 'physical',
          //   label: 'Gym Assistance',
          //   tooltip: tooltips.gymasst
          // }],
          // [{
          //   type: 'physical',
          //   label: 'Gym Assistance',
          //   tooltip: tooltips.gymasst
          // }],
          // [{
          //   type: 'physical',
          //   label: 'Jammin!!',
          //   tooltip: tooltips.jammin
          // }],
          // [{
          //   type: 'physical',
          //   label: 'Gym Assistance',
          //   tooltip: tooltips.gymasst
          // }],
          // [{
          //   type: 'physical',
          //   label: 'Gym Assistance',
          //   tooltip: tooltips.gymasst
          // }],
          null,
          null
        ]
      },
      {
        time: '4:00 PM',
        activities: [
		      // [{
          //   type: 'physical',
          //   label: 'Kids Yoga',
          //   tooltip: tooltips.yoga
          // }],
          // null,
          // [{
          //   type: 'relaxation',
          //   label: 'Stretching Session',
          //   tooltip: tooltips.streching
          // }],
          // null,
          // [{
          //   type: 'physical',
          //   label: 'Kids Yoga',
          //   tooltip: tooltips.yoga
          // }],
          null,
          null
        ]
      }
    ]
  },
  bbo: {
    days: ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'],
    data: [
      {
        time: '8:00 AM',
        activities: [
          [{
            type: 'relaxation',
            label: 'Couples Stretching',
            tooltip: tooltips.couplesstrch
          }, /*{
            type: 'field',
            label: 'Beginners Tennis',
            tooltip: tooltips.begginer
          }*/],
          [{
            type: 'relaxation',
            label: 'Power Walk',
            tooltip: tooltips.powerwalk
          }, /*{
            type: 'field',
            label: 'Beginners Tennis',
            tooltip: tooltips.begginer
          }*/],
          [/*{
            type: 'field',
            label: 'Beginners Tennis',
            tooltip: tooltips.begginer
          }*/],
          [{
            type: 'relaxation',
            label: 'Stretching Session',
            tooltip: tooltips.streching
          }, /*{
            type: 'field',
            label: 'Beginners Tennis',
            tooltip: tooltips.begginer
          }*/],
          [{
            type: 'physical',
            label: 'Caribbean Beach Shred',
            tooltip: tooltips.caribnbchs
          }, /*{
            type: 'field',
            label: 'Beginners Tennis',
            tooltip: tooltips.begginer
          }*/],
          null,
          null
        ]
      },
      {
        time: '9:00 AM',
        activities: [
          [/*{
            type: 'field',
            label: 'Advanced Tennis',
            tooltip: tooltips.field
          }*/],
          [/*{
            type: 'field',
            label: 'Advanced Tennis',
            tooltip: tooltips.field
          }*/],
          [/*{
            type: 'field',
            label: 'Advanced Tennis',
            tooltip: tooltips.field
          }*/],
          [/*{
            type: 'field',
            label: 'Advanced Tennis',
            tooltip: tooltips.field
          }*/],
          [/*{
            type: 'field',
            label: 'Teens Tennis',
            tooltip: tooltips.teeenstennis
          }*/],
          null,
          null
        ]
      },
      {
        time: '10:00 AM',
        activities: [
          [/*{
            type: 'field',
            label: 'Teen Tennis',
            tooltip: tooltips.teeenstennis
          }*/],
          [/*{
            type: 'field',
            label: 'Kids Camp Tennis',
            tooltip: tooltips.kidstennis
          }*/],
          [/*{
            type: 'field',
            label: 'Hit with the Pro (Additional Charges)',
            tooltip: tooltips.hitpro
          }*/],
          [/*{
            type: 'field',
            label: 'Advanced Private Lessons (Additional Charges)',
            tooltip: tooltips.field
          }*/],
          [/*{
            type: 'field',
            label: 'Hit with the Pro (Additional Charges)',
            tooltip: tooltips.hitpro
          }*/],
          null,
          null
        ]
      },
      {
        time: '10:30 AM',
        activities: [
          [{
            type: 'water',
            label: 'Aqua Fitness',
            tooltip: tooltips.aqua
          }],
          null,
          [{
            type: 'water',
            label: 'Aqua Fitness',
            tooltip: tooltips.aqua
          }],
          [{
            type: 'water',
            label: 'Aqua Fitness',
            tooltip: tooltips.aqua
          }],
          null,
          null,
          null
        ]
      },
      {
        time: '11:15 AM',
        activities: [
          null,
          [{
            type: 'water',
            label: 'Splish-Splash',
            tooltip: tooltips.splish
          }],
		  null,	
          null,
          null,
          null,
          null
        ]
      },
      {
        time: '1:30 PM',
        activities: [
          null,
		  null,	
          null,
          null,
          [{
            type: 'physical',
            label: 'Kids Yoga',
            tooltip: tooltips.yoga
          }],
          null,
          null
        ]
      },
      {
        time: '3:00 PM',
        activities: [
          null,
          [{
            type: 'physical',
            label: 'BasketBall',
            tooltip: tooltips.basketball
          }],
          null,
          null,
          [{
            type: 'physical',
            label: 'Absolute -ABS',
            tooltip: tooltips.absoluteabs
          }],
          null,
          null
        ]
      },
      {
        time: '3:30 PM',
        activities: [
          [/*{
            type: 'field',
            label: 'Hit with the Pro (Additional Charges)',
            tooltip: tooltips.hitpro
          }*/],
          [/*{
            type: 'field',
            label: 'Hit with the Pro (Additional Charges)',
            tooltip: tooltips.hitpro
          }*/],
          [/*{
            type: 'field',
            label: 'Hit with the Pro (Additional Charges)',
            tooltip: tooltips.hitpro
          }*/],
          [{
            type: 'physical',
            label: 'BasketBall',
            tooltip: tooltips.basketball
          }],
          null,
          null,
          null
        ]
      },
      {
        time: '4:00 PM',
        activities: [
          [{
            type: 'physical',
            label: 'Gym Assistance',
            tooltip: tooltips.gymasst
          }],
          [{
            type: 'physical',
            label: 'Gym Assistance',
            tooltip: tooltips.gymasst
          }, /*{
            type: 'field',
            label: 'Kids Private Tennis (Additional Charges)',
            tooltip: tooltips.kidstennis
          }*/],
          [{
            type: 'physical',
            label: 'Tabata Session',
            tooltip: tooltips.tabata
          },{
            type: 'physical',
            label: 'Gym Assistance',
            tooltip: tooltips.gymasst
          },/*{
            type: 'field',
            label: 'Advanced Private Lesson (Additional Charges)',
            tooltip: tooltips.field
          }*/],
          [{
            type: 'physical',
            label: 'Gym Assistance',
            tooltip: tooltips.gymasst
          }, /*{
            type: 'field',
            label: 'Intermediate Private Lessons (Additional Charges)',
            tooltip: tooltips.field
          }*/],
          [/*{
            type: 'field',
            label: 'Kids Private Tennis (Additional Charges)',
            tooltip: tooltips.kidstennis
          }*/],
          null,
          null
        ]
      }
    ]
  },
  btc: {
    days: ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'],
    data: [
      { 
        time: '7:00 AM',
        activities: [
          [{
            type: 'physical',
            label: 'Absolute -ABS',
            tooltip: tooltips.absoluteabs
          }],
          [{
            type: 'relaxation',
            label: 'Stretching Session',
            tooltip: tooltips.streching
          }],
          [{
            type: 'relaxation',
            label: 'Power Walk',
            tooltip: tooltips.powerwalk
          }],
          [{
            type: 'relaxation',
            label: 'Couples Stetching',
            tooltip: tooltips.couplesstrch
          }],
          [{ 
            type: 'relaxation',
            label: 'Stretching Session',
            tooltip: tooltips.streching
          }],
          null,
          null
        ] 
      },
      {
        time: '8:00 AM',
        activities: [
          [{
            type: 'relaxation',
            label: 'Zumba Class',
            tooltip: tooltips.zumba
          }],
          [{
            type: 'physical',
            label: 'Tabata Training (16yrs & older)',
            tooltip: tooltips.tabata
          }],
          [{
            type: 'relaxation',
            label: 'Zumba Class',
            tooltip: tooltips.zumba
          }],
          [{
            type: 'physical',
            label: 'Tabata Training (16yrs & older)',
            tooltip: tooltips.tabata
          }],
          [{
            type: 'relaxation',
            label: 'Zumba Class',
            tooltip: tooltips.zumba
          }],
          null,
          null
        ]
      },
      {
        time: '10:30 AM',
        activities: [
          [{ 
            type: 'water',
            label: 'Aqua Tabata',
            tooltip: tooltips.aquatabata
          }],
          [{
            type: 'water',
            label: 'Aqua Fitness',
            tooltip: tooltips.aqua
          }],
          [{
            type: 'water',
            label: 'Splish-Splash',
            tooltip: tooltips.splish
          }],
          [{
            type: 'water',
            label: 'Aqua Tabata',
            tooltip: tooltips.aquatabata
          }],
          [{
            type: 'water',
            label: 'Aqua Fitness',
            tooltip: tooltips.aqua
          }],
          null,
          null
        ]
      },
      {
        time: '3:00 PM',
        activities: [
          [{
            type: 'physical',
            label: 'Gym Assistance',
            tooltip: tooltips.gymasst
          }],
          [{
            type: 'physical',
            label: 'Tabata Training (16yrs & older)',
            tooltip: tooltips.tabata
          }],
          [{
            type: 'physical',
            label: 'Gym Assistance',
            tooltip: tooltips.gymasst
          }],
          [{
            type: 'physical',
            label: 'Caribbean Beach Shred',
            tooltip: tooltips.caribnbchs
          }],
          [{ 
            type: 'physical',
            label: 'Absolute -ABS',
            tooltip: tooltips.absoluteabs
          }],
          null,
          null
        ]
      }
    ]
  }
};
